import React from 'react';
import Login from '../../Login/Login';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';

export default function () {
  return (
    <>
   <NavBarTop />
          <Login />
          <br />
          <br />
          <br />
          <br />
          <br />
   <Rodape />
    </>
  )
}